<nw-card
    role="body"
    class="portfolio-card"
    [disabled]="isDisabled"
    [toggleable]="!isDisabled && toggleable"
    [selected]="!isDisabled && selected"
    (raiseEvent)="raiseEvent.emit($event)"
    [style.opacity]="isDisabled ? 0.5 : 1"
>
    <section class="portfolio-card__container">
        <div class="portfolio-card__container__name">
            @if (jisa) {
                <div
                    class="portfolio-card__container__name__jisa-child-owner"
                    data-test="jisa-owner"
                >
                    For {{ jisa.title }} {{ jisa.firstName }}
                    {{ jisa.lastName }}
                </div>
            }
            <div class="portfolio-card__container__name__name" data-test="portfolio-name">
                {{ name }}
            </div>
        </div>
        <div class="portfolio-card__container__id-and-risk">
            <span class="portfolio-card__container__id-and-risk__portfolio-id__label"
                >{{
                    accountId &&
                    (type.toLowerCase() === 'jgia' || type.toLowerCase() === 'jisa')
                        ? 'Account ID:'
                        : 'Portfolio ID:'
                }}
            </span>
            <span
                class="portfolio-card__container__id-and-risk__portfolio-id__value"
                [attr.data-test]="
                    accountId &&
                    (type.toLowerCase() === 'jgia' || type.toLowerCase() === 'jisa')
                        ? 'account-id'
                        : 'portfolio-id'
                "
                >{{
                    accountId &&
                    (type.toLowerCase() === 'jgia' || type.toLowerCase() === 'jisa')
                        ? accountId
                        : internalId || portfolioId
                }}</span
            >
            <span class="portfolio-card__container__id-and-risk__risk-level__label"
                >Risk Level:
            </span>
            <div>
                @if (strategyType === 'SRI') {
                    <nw-sri-banner
                        data-test="risk-level-sri"
                        [showCurrency]="true"
                        [riskLevel]="riskLevel"
                    >
                    </nw-sri-banner>
                } @else {
                    <span
                        data-test="risk-level-default"
                        class="portfolio-card__container__id-and-risk__risk-level__value"
                        >{{ riskLevel }}</span
                    >
                }
            </div>
        </div>
        <div class="portfolio-card__container__market-value">
            @if (showZeroMarketValue || !!marketValue) {
                <span data-test="portfolio-value">
                    {{
                        marketValue || 0
                            | currency: baseCurrency : 'symbol-narrow' : '1.0-0'
                    }}
                </span>
            }
        </div>
    </section>
</nw-card>
